// extracted by mini-css-extract-plugin
export default {"Retry":"Retry_Retry__1uA-w","Right-Btns":"Retry_Right-Btns__TswSc","Post-Btn":"Retry_Post-Btn__65gZ9"};